module.exports = __webpack_public_path__ + "static/media/3-1.5d1dc1bd.png";